import { useToastContext } from "components/alert/ToastContext";
import { Label } from "components/input/Label";
import ItemPeriodicidade from "model/periodicidade/ItemPeriodicidade";
import Periodicidade from "model/periodicidade/Periodicidade";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { useEffect } from "react";
import { PeriodicidadeService } from "service/periodicidade/PeriodicidadeService";
import { converterData } from "utils/convert";

type Props = {
    visible: boolean;
    value: Periodicidade
    onChange: (value: Periodicidade) => void;
    onConfirm: (value: Periodicidade) => void;
    onCancel: () => void;
}

const periodicidadeService = new PeriodicidadeService()

export default function ModalSelecaoPeriodicidade(props: Props) {
    const { msgAlerta } = useToastContext();
    useEffect(() => {
        if (!props.value) {
            props.onChange(new Periodicidade())
        }
    }, [])

    function dayHandleClick(day: string) {
        isDaySelected(day) ? removeDay(day) : addDay(day)
    }

    function addDay(day: string) {
        props.onChange({ ...props.value, itens: [...props.value.itens, new ItemPeriodicidade(0, null, day, null, null, null)] })
    }
    function removeDay(day: string) {
        props.onChange({ ...props.value, itens: props.value.itens.filter(item => item.diaSemana !== day) })
    }

    function isDaySelected(day: string): boolean {
        return props.value.itens.findIndex(item => item.diaSemana === day) > -1
    }

    function mesHandleClick(mes: string) {
        isMesSelected(mes) ? removeMes(mes) : addMes(mes);
    }

    function addMes(mes: string) {
        props.onChange({ ...props.value, itens: [...props.value.itens, new ItemPeriodicidade(0, null, null, null, null, mes)] })
    }

    function removeMes(mes: string) {
        props.onChange({ ...props.value, itens: props.value.itens.filter(item => item.mes !== mes) })
    }

    function isMesSelected(mes: string): boolean {
        return props.value.itens.findIndex(item => item.mes === mes) > -1
    }

    function diaMesHandleClick(dia: number) {
        isDiaMesSelected(dia) ? removeDiaMes(dia) : addDiaMes(dia);
    }

    function addDiaMes(dia: number) {
        props.onChange({ ...props.value, itens: [...props.value.itens, new ItemPeriodicidade(0, null, null, null, dia, null)] })
    }

    function removeDiaMes(dia: number) {
        props.onChange({ ...props.value, itens: props.value.itens.filter(item => item.diaMes !== dia) })
    }

    function isDiaMesSelected(dia: number): boolean {
        return props.value.itens.findIndex(item => item.diaMes === dia) > -1
    }

    const footer = <div>
        <Button label="Cancelar" icon="pi pi-times" className="p-button-text p-button-danger" onClick={props.onCancel} />
        <Button label="Confirmar" icon="pi pi-check" className="p-button-text" onClick={() => podeConfirmar() ? props.onConfirm(props.value) : null} />
    </div>

    function podeConfirmar(): boolean {
        if (!props.value?.personalizada) {
            if (!props.value?.periodo) {
                msgAlerta("Periodicidade", "Periodo é obrigatório")
                return false;
            }
            if (!props.value?.tipoPeriodo) {
                msgAlerta("Periodicidade", "Tipo de periodo é obrigatório")
                return false;
            }
            if (!periodicidadeService.getTipoPeriodo(props.value?.tipoPeriodo)) {
                msgAlerta("Periodicidade", "Selecione um tipo de período válido")
                return false;
            }
        } else {
            if (!periodicidadeService.getTipoPeriodoPersonalizado(props.value?.tipoPeriodo)) {
                msgAlerta("Periodicidade", "Selecione um tipo de período válido")
                return false;
            }
        }
        return true;
    }

    function generateRange(n: number): number[] {
        let range = [];
        for (let i = 0; i < n; i++) range[i] = i + 1;
        return range;
    }

    return (
        <Dialog visible={props.visible} style={{ width: '65vw', minHeight: "50vh" }} header="Selecione a periodicidade" footer={footer} modal={true} onHide={props.onCancel}>
            <div style={{ width: "100%", display: "flex", flexDirection: "column", rowGap: 16 }}>
                <div style={{ display: "flex", flexDirection: "column" }}>
                    <label style={{ fontWeight: "bold" }}>Última geração</label>
                    <InputText value={props.value?.dataUltimaGeracao ? converterData(props.value.dataUltimaGeracao) : ""} readOnly style={{ width: 150 }} />
                </div>
                <div>
                    <Checkbox inputId="ativo" name="ativo"
                        checked={props.value?.ativa}
                        onChange={(e) => props.onChange({ ...props.value, ativa: e.checked as boolean })}
                    />
                    <label htmlFor="ativo" style={{ marginLeft: 8 }}>Ativo?</label>
                </div>

                <div>
                    <Checkbox inputId="person"
                        checked={props.value?.personalizada}
                        onChange={(e) => props.onChange({ ...props.value, personalizada: e.checked as boolean, itens: [] })}
                    />
                    <label htmlFor="person" style={{ marginLeft: 8 }}>Personalizada?</label>
                </div>

                {!props.value?.personalizada ? <div style={{ display: "flex", flexDirection: "column" }}>
                    <Label label="Periodo" obrigatorio={true} />
                    <div style={{ width: "100%" }}>
                        <InputNumber
                            style={{ width: "10%" }}
                            inputStyle={{ width: "100%" }}
                            value={props.value?.periodo}
                            onChange={(e) => props.onChange({ ...props.value, periodo: e.value as number })}
                        />
                        <Dropdown
                            style={{ width: "30%", marginLeft: 8 }}
                            options={periodicidadeService.getTiposPeriodo()}
                            value={props.value?.tipoPeriodo} optionLabel="label" optionValue="value"
                            onChange={(e) => props.onChange({ ...props.value, tipoPeriodo: e.value as string })}
                        />
                    </div>

                </div> : null}

                {props.value?.personalizada ? <div style={{ display: "flex", flexDirection: "column" }}>
                    <Label label="Tipo" obrigatorio={true} />
                    <Dropdown
                        style={{ width: "25%" }}
                        options={periodicidadeService.getTiposPeriodoPersonalizado()}
                        value={props.value?.tipoPeriodo} optionLabel="label" optionValue="value"
                        onChange={(e) => props.onChange({ ...props.value, tipoPeriodo: e.value as string, itens: [] })}
                    />
                </div> : null}

                {props.value?.personalizada ? <div style={{ display: "flex", flexDirection: "row", width: "100%" }}>
                    {props.value?.tipoPeriodo == "DIA" ?
                        <div style={{ width: "100%", display: "flex", columnGap: 8, rowGap: 8, flexWrap: "wrap" }}>
                            {periodicidadeService.getDiasSemana().map((item, index) => {
                                return <Button key={index} label={item.label} className={isDaySelected(item.value) ? "" : "p-button-outlined"} onClick={() => dayHandleClick(item.value)} />
                            })}
                        </div>
                        : null}
                    {props.value?.tipoPeriodo == "MES" ?
                        <div style={{ width: "100%", display: "flex", columnGap: 8, rowGap: 8, flexWrap: "wrap" }}>
                            {periodicidadeService.getMeses().map((item, index) => {
                                return <Button key={index} label={item.label} className={isMesSelected(item.value) ? "" : "p-button-outlined"} onClick={() => mesHandleClick(item.value)} />
                            })}
                        </div>
                        : null}
                    {props.value?.tipoPeriodo == "DIA_MES" ?
                        <div style={{ width: "100%", display: "flex", columnGap: 8, rowGap: 8, flexWrap: "wrap" }}>
                            {generateRange(31).map((dia, index) => {
                                return <Button key={index} label={dia.toString()} className={isDiaMesSelected(dia) ? "" : "p-button-outlined"} onClick={() => diaMesHandleClick(dia)} />
                            })}
                        </div>
                        : null}
                </div> : null}
            </div>
        </Dialog>
    )
}